<template>
    <filter-group
        :options="options"
        :title="filter.text"
        :id="fKey"
        :selected="filter.value"
        :first-option="filter.firstOption"
        :background-color="filter.backgroundColor"
        :clear="true"
        :single-select="filter.singleSelect"
        @set-filter="setFilter"
    />
</template>

<script>
import filterMixin from './filter.mixin'

export default {
    mixins: [filterMixin],

    methods: {
        setFilter(value) {
            this.$emit('set-filter', value)
        }
    },

    computed: {
        options() {
            return this.filter.options || this.$store.getters[this.filter.getter] || []
        }
    }
}
</script>